// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsBestTimeToCall;
(function (HhsBestTimeToCall) {
    HhsBestTimeToCall["Afternoon"] = "afternoon";
    HhsBestTimeToCall["Evening"] = "evening";
    HhsBestTimeToCall["Morning"] = "morning";
})(HhsBestTimeToCall || (HhsBestTimeToCall = {}));
//# sourceMappingURL=hhsBestTimeToCall.js.map